export default {"src":"/statics/ecommerce/_next/static/media/big-info.82cae6af.svg","height":187,"width":391,"blurWidth":0,"blurHeight":0};